import { Stack } from '@superdispatch/ui';
import { Button } from '@superdispatch/ui-lab';
import { FormikDrawerContent } from 'shared/form/FormikDrawer';
import { useDocumentTitle } from 'shared/layout/DocumentTitle';
import {
  BusinessDetailsForm,
  useBusinessDetailsSetupForm,
} from '../../../profile/superpay/business-details/BusinessDetailsForm';
import { BusinessDetailsInfo } from '../../../profile/superpay/business-details/BusinessDetailsInfo';
import { MobileDrawerFormLayout } from '../../../profile/superpay/MobileDrawerFormContent';
import { BusinessDetailsPageLoading } from './BusinessDetailsPageLoading';
import { SuperPayWebviewHeader } from './SuperPayWebviewHeader';

export function BusinessDetailsWebViewPage() {
  const { formik, isFetching, isMoovAvailable, isSubmitDisabled } =
    useBusinessDetailsSetupForm();

  useDocumentTitle('Setup SuperPay');

  return (
    <SuperPayWebviewHeader>
      {isFetching ? (
        <BusinessDetailsPageLoading />
      ) : (
        <MobileDrawerFormLayout
          action={
            <Button
              disabled={isSubmitDisabled}
              onClick={() => {
                void formik.submitForm();
              }}
              pending={formik.isSubmitting || isFetching}
              fullWidth={true}
            >
              Continue
            </Button>
          }
        >
          <FormikDrawerContent
            formik={formik}
            title="Business Details"
            disableClose={true}
            disableAutoClose={true}
            actions={null}
          >
            <Stack space="small">
              <BusinessDetailsInfo isMoovAvailable={isMoovAvailable} />
              <BusinessDetailsForm disabled={!isMoovAvailable} />
            </Stack>
          </FormikDrawerContent>
        </MobileDrawerFormLayout>
      )}
    </SuperPayWebviewHeader>
  );
}
